import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconList3 = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 14'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M23.000,8.000 L7.000,8.000 C6.448,8.000 6.000,7.552 6.000,7.000 C6.000,6.448 6.448,6.000 7.000,6.000 L23.000,6.000 C23.552,6.000 24.000,6.448 24.000,7.000 C24.000,7.552 23.552,8.000 23.000,8.000 ZM23.000,3.000 L7.000,3.000 C6.448,3.000 6.000,2.552 6.000,2.000 C6.000,1.448 6.448,1.000 7.000,1.000 L23.000,1.000 C23.552,1.000 24.000,1.448 24.000,2.000 C24.000,2.552 23.552,3.000 23.000,3.000 ZM3.000,14.000 L1.000,14.000 C0.448,14.000 0.000,13.552 0.000,13.000 L0.000,11.000 C0.000,10.448 0.448,10.000 1.000,10.000 L3.000,10.000 C3.552,10.000 4.000,10.448 4.000,11.000 L4.000,13.000 C4.000,13.552 3.552,14.000 3.000,14.000 ZM3.000,9.000 L1.000,9.000 C0.448,9.000 0.000,8.552 0.000,8.000 L0.000,6.000 C0.000,5.448 0.448,5.000 1.000,5.000 L3.000,5.000 C3.552,5.000 4.000,5.448 4.000,6.000 L4.000,8.000 C4.000,8.552 3.552,9.000 3.000,9.000 ZM3.000,4.000 L1.000,4.000 C0.448,4.000 0.000,3.552 0.000,3.000 L0.000,1.000 C0.000,0.448 0.448,0.000 1.000,0.000 L3.000,0.000 C3.552,0.000 4.000,0.448 4.000,1.000 L4.000,3.000 C4.000,3.552 3.552,4.000 3.000,4.000 ZM7.000,11.000 L23.000,11.000 C23.552,11.000 24.000,11.448 24.000,12.000 C24.000,12.552 23.552,13.000 23.000,13.000 L7.000,13.000 C6.448,13.000 6.000,12.552 6.000,12.000 C6.000,11.448 6.448,11.000 7.000,11.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconList3.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
